import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./my-promotions.css";
import { useNavigate } from "react-router-dom";
let MyPromotions = () => {
  const navigate = useNavigate();
  let [TableData, setTableData] = useState([
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Created",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Complated",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "Make it Live",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Created",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Complated",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "Make it Live",
      action: "Active",
    },
  ]);
  const ActionHandler = (e) => {
    if (e.target.value === "Edit") {
      navigate("/my-promotions/create", { state: { type: "Edit" } });
    }
  };
  const handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() =>
                  navigate("/my-promotions/create", {
                    state: { type: "Create" },
                  })
                }
              >
                <p className="page-header-button-text">Create promotion</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={5} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by title"
                />
              </div>
            </Grid>

            <Grid item xl={5} lg={5} md={5} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">promotion</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="my-promotions-table-image-heading">Image</th>
                <th className="my-promotions-table-title-heading">Title</th>
                <th className="my-promotions-table-discount-heading">
                  Discount
                </th>
                <th className="my-promotions-table-country-heading">Country</th>
                <th className="my-promotions-table-location-heading">
                  Location
                </th>
                <th className="my-promotions-table-status-heading">Status</th>
                <th className="my-promotions-table-action-heading">Action</th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-data">
                      <img
                        src={ProfileImg}
                        className="my-promotions-table-image"
                      />
                    </td>

                    <td className="table-data">{tableValue.title}</td>
                    <td className="table-center-data">{tableValue.discount}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.location}</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Created"
                              ? "#FFD1B0"
                              : tableValue.status === "Make it Live"
                              ? "#EAD4FF"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Created"
                              ? "#B84D00"
                              : tableValue.status === "Make it Live"
                              ? "#663399"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Created"
                          selected={
                            tableValue.status === "Created" && "selected"
                          }
                        >
                          Created
                        </option>
                        <option
                          value="Make it Live"
                          selected={
                            tableValue.status === "Make it Live" && "selected"
                          }
                        >
                          Make it Live
                        </option>
                        <option
                          value="Complated"
                          selected={
                            tableValue.status === "Complated" && "selected"
                          }
                        >
                          Complated
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={ActionHandler}
                      >
                        <option value="">Action</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default MyPromotions;
